module.exports = "/static/media/dtmf-7.ba927e1a.mp3";